// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ZIST","header":"ReportDetails_header__1rIsl","title":"ReportDetails_title__22hQK","left":"ReportDetails_left__pUnal"};